<template>
  <div class="container">
    <div class="main_wrap">
      <section class="section f ds_main">
        <div class="lside mr12">
          <p class="green f16">
            {{ $t('now_available') }}
          </p>
          <h1>{{ $t('ds.title') }}</h1>
          <p class="light">
            {{ $t('ds.subtitle') }}
          </p>
          <a
            class="btn btn-primary btn-green mt24 h50 fi"
            href="https://discord.com/oauth2/authorize?client_id=838062898018254879&permissions=309312&scope=bot"
            target="_blank"
            @click="sendGtag"
          >
            <i class="i-discord f21" />
            <span class="f15">{{ $t('ds.add') }}</span>
          </a>
        </div>
        <div class="rside">
          <div class="overlay">
            <img
              :src="getImageFromProxy(`${siteHost}/img/discord/01.png`, '650:156')"
              alt="discord"
            >
          </div>
          <div class="request mr24 mb24">
            <div class="f nw fe top">
              <span class="lighten">
                {{ $t('today') }} {{ $t('at').toLowerCase() }} 20:34
              </span>
              <b class="f15 ml10 mr10">CS2 lover</b>
              <img
                alt="csgo"
                class="wh24 round"
                height="24"
                src="/img/games/game-csgo.png"
                width="24"
              >
            </div>
            <button class="btn btn-primary mt12 mla f15 h50">
              !price AK Redline ft
            </button>
          </div>
          <div class="set">
            <div class="f fs top">
              <svg class="wh28">
                <use xlink:href="/icons/sprite.svg#i_logo" />
              </svg>
              <b class="f15 ml10 mr10">CSMC</b>
              <span class="lighten">
                {{ $t('today') }} {{ $t('at').toLowerCase() }} 20:34
              </span>
            </div>
            <div class="block mr10 mt12">
              <p class="lighten f15">
                {{ $t('prices_for') }} AK-47 | Redline ({{ $t('Field-Tested') }})
              </p>
              <div class="f mt20">
                <div class="m_price">
                  <div class="f fs f12">
                    <img

                      :src="getImageFromProxy('https://api.csmarketcap.com/images/waxpeer.png', '150:150')"
                      alt="waxpeer"
                      class="wh20 round mr10"
                    >
                    <span class="light">Waxpeer</span>
                  </div>
                  <div class="mt8">
                    <p :class="`c-${currencyName}`">
                      {{ getPrice(30880) }}
                    </p>
                  </div>
                </div>
                <div class="m_price">
                  <div class="f fs f12">
                    <img

                      :src="getImageFromProxy('https://api.csmarketcap.com/images/buff163.png', '150:150')"
                      alt="vmarket"
                      class="wh20 round mr10"
                    >
                    <span class="light">BUFF</span>
                  </div>
                  <div class="mt8">
                    <p :class="`c-${currencyName}`">
                      {{ getPrice(32310) }}
                    </p>
                  </div>
                </div>
                <div class="m_price">
                  <div class="f fs f12">
                    <img

                      :src="getImageFromProxy('https://api.csmarketcap.com/images/csmoney.png', '150:150')"
                      alt="marketcs"
                      class="wh20 round mr10"
                    >
                    <span class="light">CSMoney</span>
                  </div>
                  <div class="mt8">
                    <p :class="`c-${currencyName}`">
                      {{ getPrice(31090) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section ds_tools">
        <div class="section-header">
          <div class="f fs">
            <h2 class="f20">
              {{ $t('ds.features_tools') }}
            </h2>
            <svg class="wh14 ml10">
              <use xlink:href="/icons/sprite.svg#i_blink" />
            </svg>
          </div>
          <div class="subtitle light f13">
            {{ $t('ds.features_tools_desc') }}
          </div>
        </div>
        <div class="section-body">
          <div class="f cards">
            <div class="f card mr16">
              <div class="lside">
                <h2>{{ $t('ds.inventory_tracking') }}</h2>
                <p class="light mt12 mb20">
                  {{ $t('ds.inventory_tracking_desc') }}
                </p>
                <div class="f fw toolbar">
                  <button class="btn btn-primary fg mr10">
                    !&nbsp;&nbsp;inv
                  </button>
                  <button class="btn btn-primary fg mr10">
                    !&nbsp;&nbsp;csv
                  </button>
                  <button class="btn btn-primary fg mr10">
                    !&nbsp;&nbsp;details
                  </button>
                </div>
              </div>
              <div class="rside set">
                <div class="f fs top mb12">
                  <svg class="wh28">
                    <use xlink:href="/icons/sprite.svg#i_logo" />
                  </svg>
                  <b class="f15 ml10 mr10">CSMC</b>
                  <span class="lighten">
                    {{ $t('today') }} {{ $t('at').toLowerCase() }} 20:34
                  </span>
                </div>
                <div class="block mr10">
                  <p class="light f15">
                    {{ $t('ds.inventory_worth') }}
                  </p>
                  <p
                    :class="`c-${currencyName}`"
                    class="white f15 "
                  >
                    {{ getPrice(23131050) }}
                  </p>
                  <p class="light f13">
                    {{ $t('ds.changed_about') }} 0%
                  </p>
                  <div class="del" />
                  <p class="light f15">
                    {{ $t('ds.inventory_was') }}
                  </p>
                  <p
                    :class="`c-${currencyName}`"
                    class="white f15 "
                  >
                    {{ getPrice(23131050) }}
                  </p>
                  <p class="light f13">
                    {{ $t('yesterday') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="f card">
              <div class="lside">
                <h2>{{ $t('ds.query_title') }}</h2>
                <p class="light mt12 mb20">
                  {{ $t('ds.query_desc') }}
                </p>
                <div class="toolbar">
                  <button class="btn btn-primary fg mr10">
                    !&nbsp;&nbsp;price<span class="ml10 light">{{
                      $t('item_name')
                    }}</span>
                  </button>
                </div>
                <span class="f light mt12 op08">
                  {{ $t('ds.eg') }} !price awp dlore ft</span>
              </div>
              <div class="rside set">
                <div class="f fs top mb12">
                  <svg class="wh28">
                    <use xlink:href="/icons/sprite.svg#i_logo" />
                  </svg>
                  <b class="f15 ml10 mr10">CSMC</b>
                  <span class="lighten">
                    {{ $t('today') }} {{ $t('at').toLowerCase() }} 20:34
                  </span>
                </div>
                <div class="block mr10">
                  <p class="lighten f15 mb18">
                    {{ $t('prices_for') }} AK-47 | Redline ({{
                      $t('Field-Tested')
                    }})
                  </p>
                  <div class="m_price">
                    <div class="f fs f12">
                      <img

                        :src="getImageFromProxy('https://api.csmarketcap.com/images/waxpeer.png', '150:150')"
                        alt="waxpeer"
                        class="wh20 round mr10"
                      >
                      <span class="light">Waxpeer</span>
                    </div>
                    <div class="mt8">
                      <p :class="`c-${currencyName}`">
                        {{ getPrice(30310) }}
                      </p>
                    </div>
                  </div>
                  <div class="del" />
                  <div class="m_price">
                    <div class="f fs f12">
                      <img

                        :src="getImageFromProxy('https://api.csmarketcap.com/images/shadowpay.png', '150:150')"
                        alt="shadowpay"
                        class="wh20 round mr10"
                      >
                      <span class="light">ShadowPay</span>
                    </div>
                    <div class="mt8">
                      <p :class="`c-${currencyName}`">
                        {{ getPrice(31090) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="ds_footer">
        <h2 class="light mt24 op05">
          {{ $t('ds.comming_soon') }}
        </h2>
        <a
          class="btn btn-primary h50"
          href="https://discord.com/oauth2/authorize?client_id=838062898018254879&permissions=309312&scope=bot"
          target="_blank"
        >
          <i class="i-discord f21" />
          <span class="f15">{{ $t('ds.add') }}</span>
        </a>
      </section>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from '~/store';
import { getImageFromProxy } from '~/utils/get-image-url';

const config = useRuntimeConfig();
const siteHost = config.public.siteHost;
const store = useStore();
const { gtag } = useGtag();

const currencyName = computed(() => store.currency);
const currency = computed(() => store.rate);

function getPrice(price: number) {
  return ((price / 1000) * currency.value).toFixed(2);
}

function sendGtag() {
  gtag('event', 'csmarket-click', {
    event_category: 'Add to discord',
  });
}
</script>

<style lang="scss" scoped>
.main_wrap {
  padding-top: 30px;
  padding-bottom: 30px;
}

h1 {
  font-size: 3.2rem;
  margin: 1.6rem 0 2.4rem;
  line-height: 4rem;
}

.del {
  width: 100%;
  border-top: 1px solid #252930;
  border-width: 2px;
  margin: 2.4rem 0;
}

.ds {
  &_main {
    padding-bottom: 7.2rem;
    border: none;
    @media screen and (max-width: 768px) {
      flex-wrap: wrap;
      .lside {
        width: 100%;
      }
      .rside {
        margin-left: auto;
        margin-top: 3rem;
      }
    }

    .lside {
      max-width: 45rem;

      p {
        font-size: 1.6rem;
        line-height: 170%;
      }
    }

    .rside {
      max-width: 45rem;
      width: 100%;
      display: block;
      position: relative;

      .block {
        display: inline-block;
        padding-right: 2.4rem;
      }

      .overlay {
        position: absolute;
        top: 3rem;
        right: 0;
        left: -20rem;
      }

      .request,
      .set {
        position: relative;
      }
    }
  }

  &_tools {
    padding-bottom: 2rem;

    .subtitle {
      max-width: 40rem;
      margin-top: 1.6rem;
      margin-bottom: 0.8rem;
    }

    .card {
      align-items: flex-start;
      background: var(--surfaces-low-container);
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.03),
      0px 4px 4px rgba(0, 0, 0, 0.01);
      border-radius: 0.6rem;
      padding: 2.4rem;
      margin-bottom: 2rem;
      @media screen and (max-width: 1024px) {
        width: 100%;
        margin-right: 0;
        &s {
          flex-wrap: wrap;
        }
      }
      @media screen and (max-width: 480px) {
        flex-wrap: wrap;
        padding: 1.6rem;
        .lside {
          width: 100%;
          margin-bottom: 2rem;
          padding: 0;
        }
        .block {
          margin: 0;
        }
      }
    }

    .block {
      background: var(--surfaces-high-container);
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.03),
      0px 4px 4px rgba(0, 0, 0, 0.01);
      border-radius: 0.6rem;
      padding: 1.6rem;

      .white {
        margin: 0.4rem 0 1.2rem;
      }
    }

    .toolbar {
      .btn {
        margin-bottom: 1rem;
        display: inline-flex;
        padding: 0 1rem;
      }
    }

    .del {
      border-bottom: 1px solid var(--surfaces-low-container);
      margin: 1.6rem 0;
    }

    .lside {
      width: 50%;
      padding-right: 3rem;
    }

    .rside {
      flex-grow: 1;
    }
  }

  &_footer {
    text-align: center;

    .btn {
      display: inline-flex;
      margin: 1.2rem auto 0;
    }
  }
}

.block {
  background: var(--surfaces-low-container);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.03), 0 4px 4px rgba(0, 0, 0, 0.01);
  border-radius: 0.6rem;
  padding: 1.2rem 1.8rem;
}

.m_price {
}
</style>

<style lang="scss">
.section {
  .section-header {
    padding: 1.6rem 0;
    font-size: 1.8rem;
  }

  border-top: 1px solid #26262c;
  padding-top: 1.6rem;
}

.home-carousel {
  padding-bottom: 2rem;
}
</style>
